import $axios from '@/core/api-config'

class PlannerService {
  createEvent (data) {
    return $axios.post(`/api/events/create/${data.bookId}`, data)
  }

  getEventsByDate ({ startDate, finishDate, tagIds, bookIds }) {
    const booksQuery = bookIds.join(',')
    const tagQuery = tagIds ? `&tags=${tagIds.join(',')}` : ''
    return $axios.get(`/api/events?books=${booksQuery}&startDate=${startDate}&finishDate=${finishDate}${tagQuery}`)
  }

  getUpcoming ({ startDate, limit = 50, bookIds }) {
    const booksQuery = bookIds.join(',')
    return $axios.get(`/api/events/upcoming?books=${booksQuery}&startDate=${startDate}&limit=${limit}`)
  }

  getAll (bookIds) {
    const booksQuery = bookIds.join(',')
    return $axios.get(`/api/events/all?books=${booksQuery}`)
  }

  getEventTags (bookIds) {
    const booksQuery = bookIds.join(',')
    return $axios.get(`/api/events/tags?books=${booksQuery}`)
  }

  toggleTag ({ tagId, eventId, bookId }) {
    return $axios.post(`/api/events/tag/${tagId}/${eventId}/${bookId}`)
  }

  addRecurring ({ periodType, periodValue, eventId, startDate, bookId }) {
    return $axios.post(`/api/events/addRecurring/${bookId}`, { periodType, periodValue, eventId, startDate })
  }

  deleteRecurring ({ isAll, isFuture, eventId, startDate, bookId }) {
    return $axios.delete(`/api/events/deleteRecurring/${bookId}`, { data: { isAll, isFuture, eventId, startDate } })
  }

  updateRecurring ({ isAll, isFuture, eventId, startDate, periodValue, periodType, id, bookId }) {
    return $axios.put(`/api/events/updateRecurring/${bookId}`, { isAll, isFuture, eventId, startDate, periodValue, periodType, id })
  }

  updateEventTag ({ name, id, bookId }) {
    return $axios.put(`/api/events/tag/${id}/${bookId}`, { name })
  }

  delete (id, bookId) {
    return $axios.delete(`/api/events/event/${id}/${bookId}`)
  }

  update ({ id, title, subTitle, startDate, timeStart, timeEnd, projectId, bookId, newBookId, additionalInfo }) {
    return $axios.put(`/api/events/update/${id}/${bookId}`, { title, subTitle, startDate, timeStart, timeEnd, projectId, newBookId, additionalInfo })
  }

  order ({ ids, bookId }) {
    return $axios.post(`/api/events/order/${bookId}`, { ids })
  }
}

export const plannerService = new PlannerService()
